import emailValidator, {urlValidator} from '../../utils/Validate';
import {
  INSURANCE_PROVIDER_KEYS_MAPPER,
  MAX_INSTALMENTS,
  MAX_INSTALMENT_PAYMENT,
  MIN_INSTALMENTS,
  PAYMENT_METHODS,
  PROVIDER_SPOKEN_NAME_SOURCES
} from '../../constants/Mapping';
import {multiEmailValidationWithHookForm} from '../email/Email';
import HelperUtils, {
  checkIfNaturalNumber,
  convertToAmount
} from '../../utils/HelperUtils';
import {CardMachineFormType, ProviderFormType} from './ClinicsFormType';

export const addClinicValidationWithHookForm = (
  values: any,
  advancedEdit: boolean,
  paymentPlanDetailsEnabled: boolean
): any => {
  let errors: any = {
    clinic_name: '',
    primary_contact_name: '',
    primary_contact_phone: '',
    primary_contact_email: '',
    address_line: '',
    city: '',
    state: '',
    zip_postal_code: '',
    // country: '',
    sms_provider_phone: '',
    clinic_phone: '',
    merchant_id: '',
    store_id: '',
    terminal_id: '',
    emr_provider: '',
    payment_receiver_email: '',
    payment_receiver_name: '',
    forward_sms_phone: '',
    short_code: '',
    billing_phone: '',
    practice_website: '',
    is_enable: false,
    total_installments: null,
    min_instalment_amount: null,
    provider_phone_number: '',
    clinic_provider_npi: '',
    location_number: '',
    insurance_provider: '',
    tickets_report_email: '',
    prior_auth_notification_emails: '',
    appointment_need_attention_emails: '',
    appointment_escalation_sms_phones: '',
    appointment_need_attention_sms_phones: '',
    clinic_type: ''
  };
  if (advancedEdit) {
    if (!values.short_code || !values.short_code.replace(/\s/g, '').length) {
      errors.short_code = 'VALIDATORS.SHORT_CODE';
    } else {
      const rg = /^[a-zA-Z0-9]{3,10}$/;
      if (!rg.test(values.short_code)) {
        errors.short_code = 'VALIDATORS.INVALID_SHORT_CODE';
      }
    }
    if (
      !values.sms_provider_phone ||
      !values.sms_provider_phone.replace(/\s/g, '').length
    ) {
      errors.sms_provider_phone = 'VALIDATORS.SMS_PROVIDER_PHONE';
    } else if (values?.sms_provider_phone?.length < 10) {
      errors.sms_provider_phone = 'VALIDATORS.INVALID_SMS_PROVIDER_PHONE';
    }
    Object.keys(values)
      .filter((key: string) => key.includes('phone'))
      .map((key: any) => {
        if (
          key.includes('number') &&
          (!values[key] || !values[key]?.replace(/\s/g, '').length)
        ) {
          errors[key] = 'VALIDATORS.NUMBER_TYPE_PROVIDER_PHONE';
        } else if (key.includes('number') && values[key]?.length < 10) {
          errors[key] = 'VALIDATORS.INVALID_PROVIDER_PHONE_NUMBER_TYPE';
        } else if (key.includes('type') && !values[key]) {
          errors[key] = 'VALIDATORS.NUMBER_TYPE_FIELD';
        }
      });
    Object.keys(values)
      .filter((key: string) => key.startsWith('phone_type_'))
      .forEach((typeKey: string) => {
        const index = typeKey.replace('phone_type_', '');
        const phoneType = String(values[typeKey] || '').toLowerCase();
        if (
          (phoneType === 'voice assistant' ||
            phoneType === 'voice_assistant') &&
          !values[`phone_language_${index}`]
        ) {
          errors[`phone_language_${index}`] =
            'VALIDATORS.VOICE_ASSISTANT_LANGUAGE';
        }
      });
    // Payment method is optional in advance edit; validate provider fields only when a provider is selected
    if (values.payment_provider === PAYMENT_METHODS.OPENEDGE) {
      if (!values.web_id) {
        errors.web_id = 'VALIDATORS.WEB_ID';
      }
      if (!values.t_id) {
        errors.t_id = 'VALIDATORS.T_ID';
      }
      if (!values.api_id) {
        errors.api_id = 'VALIDATORS.API_ID';
      }
      if (values.machines_count > 0 && !values.card_machine_tid) {
        errors.card_machine_tid = 'VALIDATORS.CARD_MACHINE_T_ID';
      }
      if (values.machines_count > 0 && !values.card_machine_api_id) {
        errors.card_machine_api_id = 'VALIDATORS.CARD_MACHINE_AUTH_KEY';
      }
    } else if (values.payment_provider === PAYMENT_METHODS.INSTAMED) {
      if (!values.merchant_id) {
        errors.merchant_id = 'VALIDATORS.MERCHANT_ID';
      }
      if (!values.store_id) {
        errors.store_id = 'VALIDATORS.STORE_ID';
      }
      if (!values.terminal_id) {
        errors.terminal_id = 'VALIDATORS.TERMINAL_ID';
      }
      if (!values.account_id) {
        errors.account_id = 'VALIDATORS.ACCOUNT_ID';
      }
      if (!values.corporate_id) {
        errors.corporate_id = 'VALIDATORS.CORPORATE_ID';
      }
    }

    if (
      !values.patientShared &&
      (!values.emr_provider || !values.emr_provider.replace(/\s/g, '').length)
    ) {
      errors.emr_provider = 'VALIDATORS.EMR_PROVIDER';
    }
  } else {
    if (!values.clinic_name || !values.clinic_name.replace(/\s/g, '').length) {
      errors.clinic_name = 'VALIDATORS.CLINIC_NAME';
    }
    if (values.paymentsEnabled) {
      if (!values.total_installments || values.total_installments === null) {
        if (paymentPlanDetailsEnabled) {
          errors.total_installments = 'VALIDATORS.MAX_INSTALMENTS';
        }
      }
      if (values.total_installments <= 0) {
        if (!paymentPlanDetailsEnabled) {
          errors.total_installments = 'VALIDATORS.REQUIRED_NO_OF_INSTALMENTS';
        }
      }
      if (
        values.total_installments &&
        Number(values.total_installments) < MIN_INSTALMENTS
      ) {
        if (paymentPlanDetailsEnabled) {
          errors.total_installments = 'VALIDATORS.REQUIRED_NO_OF_INSTALMENTS';
        }
      }
      if (
        values.total_installments &&
        Number(values.total_installments) < MIN_INSTALMENTS
      ) {
        if (!paymentPlanDetailsEnabled) {
          errors.total_installments = 'VALIDATORS.REQUIRED_NO_OF_INSTALMENTS';
        }
      }

      if (
        values.total_installments &&
        Number(values.total_installments) > MAX_INSTALMENTS
      ) {
        if (paymentPlanDetailsEnabled) {
          errors.total_installments = 'VALIDATORS.MAX_INSTALLMENTS';
        }
      }

      if (paymentPlanDetailsEnabled && values.paymentsEnabled) {
        // HANDLING TOTAL WEEKLY INSTALLMENTS
        if (
          !values.total_weekly_installments ||
          values.total_weekly_installments === null
        ) {
          errors.total_weekly_installments = 'VALIDATORS.WEEKLY_INSTALLMENTS';
        } else if (Number(values.total_weekly_installments) < MIN_INSTALMENTS) {
          errors.total_weekly_installments =
            'VALIDATORS.WEEKLY_MINIMUM_INSTALLMENTS';
        } else if (Number(values.total_weekly_installments) > MAX_INSTALMENTS) {
          errors.total_weekly_installments =
            'VALIDATORS.WEEKLY_MAXIMUM_INSTALLMENTS';
        }
        // HANDLING TOTAL BI-WEEKLY INSTALLMENTS
        if (
          !values.total_bi_weekly_installments ||
          values.total_bi_weekly_installments === null
        ) {
          errors.total_bi_weekly_installments =
            'VALIDATORS.BI_WEEKLY_INSTALLMENTS';
        } else if (
          Number(values.total_bi_weekly_installments) < MIN_INSTALMENTS
        ) {
          errors.total_bi_weekly_installments =
            'VALIDATORS.BI_WEEKLY_MINIMUM_INSTALLMENTS';
        } else if (
          Number(values.total_bi_weekly_installments) > MAX_INSTALMENTS
        ) {
          errors.total_bi_weekly_installments =
            'VALIDATORS.BI_WEEKLY_MAXIMUM_INSTALLMENTS';
        }
      }

      if (values.total_installments) {
        const checkNumber = checkIfNaturalNumber(
          values.total_installments.toString()
        );
        if (!checkNumber) {
          errors.total_installments =
            'VALIDATORS.TOTAL_NUMBER_OF_MONTHLY_ERROR';
        }
      }

      if (values.total_weekly_installments) {
        const checkNumber = checkIfNaturalNumber(
          values.total_weekly_installments.toString()
        );
        if (!checkNumber) {
          errors.total_weekly_installments =
            'VALIDATORS.TOTAL_NUMBER_OF_WEEKLY_ERROR';
        }
      }

      if (values.total_bi_weekly_installments) {
        const checkNumber = checkIfNaturalNumber(
          values.total_bi_weekly_installments.toString()
        );
        if (!checkNumber) {
          errors.total_bi_weekly_installments =
            'VALIDATORS.TOTAL_NUMBER_OF_BI_WEEKLY_ERROR';
        }
      }

      if (values.total_installments) {
        const fixDecimals = values.total_installments.toString().split('.');
        if (fixDecimals && fixDecimals.length > 1) {
          errors.total_installments =
            'VALIDATORS.TOTAL_NUMBER_OF_MONTHLY_ERROR';
        }
      }

      if (values.total_weekly_installments) {
        const fixDecimals = values.total_weekly_installments
          .toString()
          .split('.');
        if (fixDecimals && fixDecimals.length > 1) {
          errors.total_weekly_installments =
            'VALIDATORS.TOTAL_NUMBER_OF_WEEKLY_ERROR';
        }
      }

      if (values.total_bi_weekly_installments) {
        const fixDecimals = values.total_bi_weekly_installments
          .toString()
          .split('.');
        if (fixDecimals && fixDecimals.length > 1) {
          errors.total_bi_weekly_installments =
            'VALIDATORS.TOTAL_NUMBER_OF_BI_WEEKLY_ERROR';
        }
      }

      if (
        (!String(values.min_instalment_amount)
          .replace(/\$/g, '')
          .replace(/,/g, '') ||
          String(values.min_instalment_amount)
            .replace(/\$/g, '')
            .replace(/,/g, '') === null ||
          String(values.min_instalment_amount)
            .replace(/\$/g, '')
            .replace(/,/g, '') <= '0.00') &&
        paymentPlanDetailsEnabled
      ) {
        errors.min_instalment_amount = 'VALIDATORS.MIN_INSTALMENT_AMOUNT';
      }
      if (
        String(values.min_instalment_amount)
          .replace(/\$/g, '')
          .replace(/,/g, '') <= '0.00' &&
        !paymentPlanDetailsEnabled
      ) {
        errors.min_instalment_amount = 'VALIDATORS.MIN_INSTALMENT_AMOUNT';
      }
      if (
        String(values.min_instalment_amount)
          .replace(/\$/g, '')
          .replace(/,/g, '') === null &&
        values.total_installments >= 2 &&
        !paymentPlanDetailsEnabled
      ) {
        errors.min_instalment_amount = 'VALIDATORS.MIN_INSTALMENT_AMOUNT';
      }
      if (
        String(values.min_instalment_amount)
          .replace(/\$/g, '')
          .replace(/,/g, '') > '0.00' &&
        values.total_installments === null &&
        !paymentPlanDetailsEnabled
      ) {
        errors.total_installments = 'VALIDATORS.REQUIRED_NO_OF_INSTALMENTS';
      }

      if (
        String(values.min_instalment_amount)
          .replace(/\$/g, '')
          .replace(/,/g, '') === null &&
        values.total_installments >= MIN_INSTALMENTS &&
        !paymentPlanDetailsEnabled
      ) {
        errors.min_instalment_amount = 'VALIDATORS.MIN_INSTALMENT_AMOUNT';
      }

      if (
        Number(convertToAmount(values.min_instalment_amount)) >
        MAX_INSTALMENT_PAYMENT
      ) {
        errors.min_instalment_amount = 'VALIDATORS.MAX_INSTALLMENTS_AMOUNT';
      }
    }

    if (
      !values.primary_contact_name ||
      !values.primary_contact_name.replace(/\s/g, '').length
    ) {
      errors.primary_contact_name = 'VALIDATORS.PRIMARY_CONTACT_NAME';
    }
    if (
      !values.primary_contact_phone ||
      !values.primary_contact_phone.replace(/\s/g, '').length
    ) {
      errors.primary_contact_phone = 'VALIDATORS.PRIMARY_CONTACT_PHONE';
    } else if (values?.primary_contact_phone?.length < 10) {
      errors.primary_contact_phone = 'VALIDATORS.INVALID_CONTACT_PHONE';
    }
    if (
      !values.billing_phone ||
      !values.billing_phone.replace(/\s/g, '').length
    ) {
      // errors.billing_phone = 'VALIDATORS.PRIMARY_CONTACT_PHONE';
    } else if (values?.billing_phone?.length < 10) {
      errors.billing_phone = 'VALIDATORS.INVALID_BILLING_PHONE';
    }
    if (
      !values.practice_website ||
      !values.practice_website.replace(/\s/g, '').length
      // eslint-disable-next-line no-empty
    ) {
    } else {
      if (!urlValidator(String(values.practice_website).toLowerCase())) {
        errors.practice_website = 'VALIDATORS.INVALID_URL';
      } else {
        if (values.practice_website.length > 300) {
          errors.practice_website = 'VALIDATORS.URL_LENGTH';
        }
      }
    }
    if (
      !values.primary_contact_email ||
      !values.primary_contact_email.replace(/\s/g, '').length
    ) {
      errors.primary_contact_email = 'VALIDATORS.EMAIL_REQ';
    } else if (
      !emailValidator(String(values.primary_contact_email).toLowerCase())
    ) {
      errors.primary_contact_email = 'VALIDATORS.INVALID_EMAIL';
    }
    if (
      !values.address_line ||
      !values.address_line.replace(/\s/g, '').length
    ) {
      errors.address_line = 'VALIDATORS.ADDRESS_LINE';
    }
    if (!values.city || !values.city.replace(/\s/g, '').length) {
      errors.city = 'VALIDATORS.CITY';
    }
    if (!values.state || !values.state.replace(/\s/g, '').length) {
      errors.state = 'VALIDATORS.STATE';
    }
    // if (!values.country || !values.country.replace(/\s/g, '').length) {
    //   errors.country = 'VALIDATORS.COUNTRY';
    // }
    if (
      !values.zip_postal_code ||
      !values.zip_postal_code.replace(/\s/g, '').length
    ) {
      errors.zip_postal_code = 'VALIDATORS.ZIP_POSTAL_CODE';
    }
    if (
      values?.zip_postal_code &&
      (values?.zip_postal_code?.length < 5 ||
        values?.zip_postal_code?.length > 5)
    ) {
      errors.zip_postal_code = 'VALIDATORS.INVALID_ZIP_CODE';
    }
    if (
      !values.clinic_phone ||
      !values.clinic_phone.replace(/\s/g, '').length
    ) {
      errors.clinic_phone = 'VALIDATORS.CLINIC_PHONE';
    } else if (values?.clinic_phone?.length < 10) {
      errors.clinic_phone = 'VALIDATORS.INVALID_CLINIC_PHONE';
    }
    if (values.paymentsEnabled) {
      if (!values.receive_payment_notifications) {
        if (
          !values.payment_receiver_email ||
          !values.payment_receiver_email.replace(/\s/g, '').length
        ) {
          errors.payment_receiver_email =
            'VALIDATORS.PAYMENT_EMAIL_RECEIVER_EMAIL';
        } else if (
          !emailValidator(String(values.payment_receiver_email).toLowerCase())
        ) {
          errors.payment_receiver_email =
            'VALIDATORS.INVALID_PAYMENT_EMAIL_RECEIVER_EMAIL';
        }

        if (
          !values.payment_receiver_name ||
          !values.payment_receiver_name.replace(/\s/g, '').length
        ) {
          errors.payment_receiver_name =
            'VALIDATORS.PAYMENT_EMAIL_RECEIVER_NAME';
        }
      }
    }
    if (!values.should_forward_sms) {
      if (
        !values.forward_sms_phone ||
        !values.forward_sms_phone.replace(/\s/g, '').length
      ) {
        errors.forward_sms_phone = 'VALIDATORS.REQUIRED_FORWARD_SMS_PHONE';
      } else if (values?.forward_sms_phone?.length < 10) {
        errors.forward_sms_phone = 'VALIDATORS.INVALID_FORWARD_SMS_PHONE';
      }
    }
    if (values.reports && values.reports.length) {
      const emailValidation: any = multiEmailValidationWithHookForm({
        email: values.email_to_receive_report
      });
      errors.email_to_receive_report = emailValidation.email?.message;
    }
    if (
      values.default_patient_email &&
      String(values.default_patient_email).trim().length &&
      !emailValidator(String(values.default_patient_email).toLowerCase())
    ) {
      errors.default_patient_email = 'VALIDATORS.EMAIL';
    }
    // Validate eligibility verification section fields
    // if (values.clinic_provider_enable === true) {
    // if (!values.clinic_provider_npi) {
    //   errors.clinic_provider_npi = 'VALIDATORS.PRACTICE_NPI_REQUIRED';
    // }
    // else if (
    //   typeof values.clinic_provider_npi === 'string' &&
    //   values.clinic_provider_npi.length !== 10
    // ) {
    //   errors.clinic_provider_npi = 'VALIDATORS.PRACTICE_NPI_LENGTH_REQUIRED';
    // }
    // }
    if (values.enable_insurance_reminder === true) {
      if (!values.insurance_reminder_duration) {
        errors.insurance_reminder_duration = 'VALIDATORS.INVALID_DURATION';
      } else {
        const checkNumber = checkIfNaturalNumber(
          values.insurance_reminder_duration.toString()
        );
        if (!checkNumber) {
          errors.insurance_reminder_duration = 'VALIDATORS.INVALID_DURATION';
        }
      }
      if (!values.insurance_reminder_duration_units) {
        errors.insurance_reminder_duration_units =
          'VALIDATORS.REMINDER_INTERVAL_UNIT_REQUIRED';
      }
      if (!values.max_no_of_reminders) {
        errors.max_no_of_reminders = 'VALIDATORS.INVALID_DURATION';
      } else {
        const checkNumber = checkIfNaturalNumber(
          values.max_no_of_reminders.toString()
        );
        if (!checkNumber) {
          errors.max_no_of_reminders = 'VALIDATORS.INVALID_DURATION';
        }
      }
    }

    if (values.is_patient_review_enabled === true) {
      if (!values?.patient_review_url?.trim()) {
        errors.patient_review_url = 'VALIDATORS.SOCIAL_REVIEW_LINK_REQUIRED';
      } else if (values.patient_review_url.length > 300) {
        errors.patient_review_url = 'VALIDATORS.URL_SIZE';
      }
    }

    if (values.eligibilityVerificationEnable === true) {
      if (!values.insurance_provider) {
        errors.insurance_provider = 'VALIDATORS.INSURANCE_PROVIDER_REQUIRED';
      } else if (
        values.insurance_provider === INSURANCE_PROVIDER_KEYS_MAPPER.ORBIT
      ) {
        if (!values.location_number?.trim()) {
          errors.location_number = 'VALIDATORS.LOCATION_NUMBER_REQUIRED';
        }
      }
    }
    if (
      values.isPriorAuthorizationEnabled === true ||
      values.isClaimsTicketingEnabled
    ) {
      if (
        !values.tickets_report_email ||
        !values.tickets_report_email.replace(/\s/g, '').length
      ) {
        errors.tickets_report_email = 'VALIDATORS.EMAIL_REQ';
      } else {
        const emails = values.tickets_report_email
          .split(',')
          .map((e: any) => e.trim());
        let isInvalidEmail = false;
        emails.forEach((email: any) => {
          if (!emailValidator(email)) {
            isInvalidEmail = true;
          }
        });
        if (isInvalidEmail) {
          errors.tickets_report_email = 'VALIDATORS.INVALID_EMAIL';
        }
      }
    }
    if (values.isPriorAuthorizationEnabled === true) {
      if (values.prior_auth_notification_emails) {
        const emails = values.prior_auth_notification_emails
          .split(',')
          .map((e: any) => e.trim());
        let isInvalidEmail = false;
        emails.forEach((email: any) => {
          if (!emailValidator(email)) {
            isInvalidEmail = true;
          }
        });
        if (isInvalidEmail) {
          errors.prior_auth_notification_emails = 'VALIDATORS.INVALID_EMAIL';
        }
      }
    }
    const needAttentionEmailsData = Array.isArray(
      values.needAttentionEmailsData
    )
      ? values.needAttentionEmailsData
      : [];
    const needAttentionEmailIndexes = new Set<number>();
    needAttentionEmailsData.forEach((_: any, index: number) => {
      needAttentionEmailIndexes.add(index);
    });
    Object.keys(values).forEach((key: string) => {
      const match = /^need_attention_email_(\d+)$/.exec(key);
      if (match) {
        needAttentionEmailIndexes.add(Number(match[1]));
      }
    });
    let hasNeedAttentionEmail = false;
    needAttentionEmailIndexes.forEach((index: number) => {
      if (needAttentionEmailsData[index]?.isDeleted) {
        return;
      }
      const fieldKey = `need_attention_email_${index}`;
      const email = (values[fieldKey] || '').toString().trim();
      if (!email) {
        if (values.enable_appointment_need_attention_emails === true) {
          errors[fieldKey] = 'VALIDATORS.EMAIL_REQ';
        } else {
          errors[fieldKey] = '';
        }
        return;
      }
      if (!emailValidator(email)) {
        errors[fieldKey] = 'VALIDATORS.INVALID_EMAIL';
        return;
      }
      errors[fieldKey] = '';
      hasNeedAttentionEmail = true;
    });
    errors.appointment_need_attention_emails =
      values.enable_appointment_need_attention_emails === true &&
      !hasNeedAttentionEmail
        ? 'VALIDATORS.APPOINTMENT_NEED_ATTENTION_EMAIL_REQ'
        : '';
    const escalationSmsPhonesData = Array.isArray(
      values.escalationSmsPhonesData
    )
      ? values.escalationSmsPhonesData
      : [];
    const escalationSmsPhoneIndexes = new Set<number>();
    escalationSmsPhonesData.forEach((_: any, index: number) => {
      escalationSmsPhoneIndexes.add(index);
    });
    Object.keys(values).forEach((key: string) => {
      const match = /^escalation_sms_phone_(\d+)$/.exec(key);
      if (match) {
        escalationSmsPhoneIndexes.add(Number(match[1]));
      }
    });
    let hasEscalationSmsPhone = false;
    escalationSmsPhoneIndexes.forEach((index: number) => {
      if (escalationSmsPhonesData[index]?.isDeleted) {
        return;
      }
      const fieldKey = `escalation_sms_phone_${index}`;
      const phone = (values[fieldKey] || '').toString().trim();
      const phoneDigits = phone.replace(/\D/g, '');
      if (!phone) {
        if (values.enable_appointment_escalation_sms === true) {
          errors[fieldKey] = 'VALIDATORS.PRIMARY_CONTACT_PHONE';
        } else {
          errors[fieldKey] = '';
        }
        return;
      }
      if (phoneDigits.length < 10 || phoneDigits.length > 15) {
        errors[fieldKey] = 'VALIDATORS.INVALID_SMS_PROVIDER_PHONE';
        return;
      }
      errors[fieldKey] = '';
      hasEscalationSmsPhone = true;
    });
    errors.appointment_escalation_sms_phones =
      values.enable_appointment_escalation_sms === true &&
      !hasEscalationSmsPhone
        ? 'VALIDATORS.APPOINTMENT_ESCALATION_SMS_PHONE_REQ'
        : '';
    const needAttentionSmsPhonesData = Array.isArray(
      values.needAttentionSmsPhonesData
    )
      ? values.needAttentionSmsPhonesData
      : [];
    const needAttentionSmsPhoneIndexes = new Set<number>();
    needAttentionSmsPhonesData.forEach((_: any, index: number) => {
      needAttentionSmsPhoneIndexes.add(index);
    });
    Object.keys(values).forEach((key: string) => {
      const match = /^need_attention_sms_phone_(\d+)$/.exec(key);
      if (match) {
        needAttentionSmsPhoneIndexes.add(Number(match[1]));
      }
    });
    let hasNeedAttentionSmsPhone = false;
    needAttentionSmsPhoneIndexes.forEach((index: number) => {
      if (needAttentionSmsPhonesData[index]?.isDeleted) {
        return;
      }
      const fieldKey = `need_attention_sms_phone_${index}`;
      const phone = (values[fieldKey] || '').toString().trim();
      const phoneDigits = phone.replace(/\D/g, '');
      if (!phone) {
        if (values.enable_appointment_need_attention_sms === true) {
          errors[fieldKey] = 'VALIDATORS.PRIMARY_CONTACT_PHONE';
        } else {
          errors[fieldKey] = '';
        }
        return;
      }
      if (phoneDigits.length < 10 || phoneDigits.length > 15) {
        errors[fieldKey] = 'VALIDATORS.INVALID_SMS_PROVIDER_PHONE';
        return;
      }
      errors[fieldKey] = '';
      hasNeedAttentionSmsPhone = true;
    });
    errors.appointment_need_attention_sms_phones =
      values.enable_appointment_need_attention_sms === true &&
      !hasNeedAttentionSmsPhone
        ? 'VALIDATORS.APPOINTMENT_NEED_ATTENTION_SMS_PHONE_REQ'
        : '';
    if (!values.clinic_type || !values.clinic_type.replace(/\s/g, '').length) {
      errors.clinic_type = 'VALIDATORS.PRACTICE_TYPE';
    }
  }
  if (advancedEdit) {
    for (const key of Object.keys(errors)) {
      if (errors[key]) {
        return errors;
      }
    }
    if (
      !errors.sms_provider_phone &&
      !errors.emr_provider &&
      !errors.short_code &&
      !errors.web_id &&
      !errors.t_id &&
      !errors.api_id &&
      !errors.card_machine_api_id &&
      !errors.card_machine_tid &&
      !errors.merchant_id &&
      !errors.store_id &&
      !errors.terminal_id &&
      !errors.account_id &&
      !errors.corporate_id
    ) {
      errors = {};
    }
    return errors;
  }
  if (
    !errors.clinic_name &&
    !errors.primary_contact_name &&
    !errors.primary_contact_phone &&
    !errors.primary_contact_email &&
    !errors.address_line &&
    !errors.city &&
    !errors.state &&
    !errors.zip_postal_code &&
    !errors.clinic_phone &&
    !errors.payment_receiver_email &&
    !errors.payment_receiver_name &&
    !errors.forward_sms_phone &&
    !errors.email_to_receive_report &&
    !errors.billing_phone &&
    !errors.practice_website &&
    !errors.total_installments &&
    !errors.min_instalment_amount &&
    !errors.total_weekly_installments &&
    !errors.total_bi_weekly_installments &&
    !errors.clinic_provider_npi &&
    !errors.patient_review_url &&
    !errors.insurance_reminder_duration &&
    !errors.insurance_reminder_duration_units &&
    !errors.max_no_of_reminders &&
    !errors.location_number &&
    !errors.insurance_provider &&
    !errors.tickets_report_email &&
    !errors.prior_auth_notification_emails &&
    !errors.appointment_need_attention_emails &&
    !errors.appointment_escalation_sms_phones &&
    !errors.appointment_need_attention_sms_phones &&
    !errors.clinic_type &&
    !Object.keys(errors).some(
      key =>
        (key.startsWith('need_attention_email_') ||
          key.startsWith('escalation_sms_phone_') ||
          key.startsWith('need_attention_sms_phone_')) &&
        errors[key]
    )
  ) {
    errors = {};
  }
  return errors;
};

export const addGroupValidationWithHookForm = (values: any): any => {
  let errors: any = {
    clinic_group_name: '',
    admin_email: '',
    state: '',
    admin_first_name: '',
    admin_last_name: '',
    split_statement: undefined,
    group_type: '',
    skip_notification_guarantor_duration: ''
  };
  if (
    !values.clinic_group_name ||
    !values.clinic_group_name.replace(/\s/g, '').length
  ) {
    errors.clinic_group_name = 'VALIDATORS.CLINIC_GROUP_NAME';
  }
  if (!values.admin_email || !values.admin_email.replace(/\s/g, '').length) {
    errors.admin_email = 'VALIDATORS.EMAIL_REQ';
  } else if (!emailValidator(String(values.admin_email).toLowerCase())) {
    errors.admin_email = 'VALIDATORS.INVALID_EMAIL';
  }
  if (
    !values.admin_first_name ||
    !values.admin_first_name.replace(/\s/g, '').length
  ) {
    errors.admin_first_name = 'VALIDATORS.FIRST_NAME';
  }
  if (
    !values.admin_last_name ||
    !values.admin_last_name.replace(/\s/g, '').length
  ) {
    errors.admin_last_name = 'VALIDATORS.LAST_NAME';
  }
  if (!values.state || !values.state.replace(/\s/g, '').length) {
    errors.state = 'VALIDATORS.STATE';
  }
  if (values.split_statement === undefined) {
    errors.split_statement = 'VALIDATORS.SPLIT_STATEMENT';
  }
  if (!values.group_type || !values.group_type.replace(/\s/g, '').length) {
    errors.group_type = 'VALIDATORS.GROUP_TYPE';
  }
  if (
    values.max_simultaneous_appointments === undefined ||
    values.max_simultaneous_appointments === null ||
    values.max_simultaneous_appointments === '' ||
    Number(values.max_simultaneous_appointments) < 1
  ) {
    errors.max_simultaneous_appointments =
      'VALIDATORS.MAX_SIMULTANEOUS_APPOINTMENTS';
  }
  if (
    values.patients_shared === true &&
    !values.skip_notification_guarantor_duration
  ) {
    const regex = new RegExp('^(?!0+$)[0-9]{1,10}$', 'g');
    if (!regex.test(values.skip_notification_guarantor_duration)) {
      errors.skip_notification_guarantor_duration =
        'VALIDATORS.INVALID_DURATION';
    }
  }
  if (
    values.default_patient_email &&
    String(values.default_patient_email).trim().length &&
    !emailValidator(String(values.default_patient_email).toLowerCase())
  ) {
    errors.default_patient_email = 'VALIDATORS.EMAIL';
  }
  if (
    !errors.clinic_group_name &&
    !errors.admin_email &&
    !errors.state &&
    !errors.admin_first_name &&
    !errors.admin_last_name &&
    !errors.group_type &&
    !errors.max_simultaneous_appointments &&
    !errors.skip_notification_guarantor_duration &&
    !errors.default_patient_email
  ) {
    errors = {};
  }
  return errors;
};

export const updateGroupValidationWithHookForm = (values: any): any => {
  let errors: any = {};
  if (
    !values.clinic_group_name ||
    !values.clinic_group_name.replace(/\s/g, '').length
  ) {
    errors = {...errors, clinic_group_name: 'VALIDATORS.CLINIC_GROUP_NAME'};
  }
  if (!values.state || !values.state.replace(/\s/g, '').length) {
    errors = {...errors, state: 'VALIDATORS.STATE'};
  }
  if (
    values.max_simultaneous_appointments === undefined ||
    values.max_simultaneous_appointments === null ||
    values.max_simultaneous_appointments === '' ||
    Number(values.max_simultaneous_appointments) < 1
  ) {
    errors = {
      ...errors,
      max_simultaneous_appointments: 'VALIDATORS.MAX_SIMULTANEOUS_APPOINTMENTS'
    };
  }
  if (
    values.default_patient_email &&
    String(values.default_patient_email).trim().length &&
    !emailValidator(String(values.default_patient_email).toLowerCase())
  ) {
    errors = {...errors, default_patient_email: 'VALIDATORS.EMAIL'};
  }
  if (
    !errors.clinic_group_name &&
    !errors.admin_email &&
    !errors.state &&
    !errors.max_simultaneous_appointments &&
    !errors.default_patient_email
  ) {
    errors = {};
  }
  if (values.statementsEnable) {
    if (!values.send_frequent_notification_guarantor) {
      if (
        values.skip_notification_guarantor_duration ||
        values.skip_notification_guarantor_duration === ''
      ) {
        const checkNumber = checkIfNaturalNumber(
          values.skip_notification_guarantor_duration.toString()
        );
        if (!checkNumber) {
          errors.skip_notification_guarantor_duration =
            'VALIDATORS.INVALID_DURATION';
        }
      } else {
        errors.skip_notification_guarantor_duration =
          'VALIDATORS.INVALID_DURATION';
      }
      if (!values.skip_notification_guarantor_duration_unit) {
        errors.skip_notification_guarantor_duration_unit =
          'VALIDATORS.INVALID_DURATION_UNIT';
      }
    }
  }
  return errors;
};

export const addUserValidationWithHookForm = (values: any): any => {
  let errors: any = {
    first_name: '',
    last_name: '',
    email: '',
    job_title_id: '',
    roles: '',
    accOfClinics: ''
  };
  if (!values.first_name || !values.first_name.replace(/\s/g, '').length) {
    errors.first_name = 'VALIDATORS.FIRST_NAME';
  }
  if (!values.job_title_id && !values.job_title_id.replace(/\s/g, '').length) {
    errors.job_title_id = 'VALIDATORS.JOB_TITLE';
  }
  if (values.roles && values.roles.length === 0) {
    errors.roles = 'VALIDATORS.ROLES';
  }
  // if (values.clinics && values.clinics.length === 0) {
  //   errors.accOfClinics = 'VALIDATORS.ACCESS_OF_CLINICS';
  // }
  if (!values.last_name || !values.last_name.replace(/\s/g, '').length) {
    errors.last_name = 'VALIDATORS.LAST_NAME';
  }
  const {fromEdit} = values;
  // in edit mode the user has email disabled / non-edit mode for email
  if (!fromEdit) {
    if (!values.email || !values.email.replace(/\s/g, '').length) {
      errors.email = 'VALIDATORS.EMAIL_REQ';
    } else if (!emailValidator(String(values.email).toLowerCase())) {
      errors.email = 'VALIDATORS.INVALID_EMAIL';
    } else {
      const {allUsers} = values;
      if (Array.isArray(allUsers) && allUsers.length > 0) {
        const user = allUsers.find(
          (user1: any) => user1.email === values.email
        );
        if (user) {
          errors.email = 'ADD_USER.USER_EXISTS';
        }
      }
    }
  }
  if (
    !errors.first_name &&
    !errors.last_name &&
    !errors.email &&
    !errors.title &&
    !errors.roles &&
    !errors.accOfClinics
  ) {
    errors = {};
  }
  return errors;
};

export const addAdminUsersValidationWithHookForm = (values: any): any => {
  let errors: any = {
    first_name: '',
    last_name: '',
    email: ''
  };
  if (!values.first_name || !values.first_name.replace(/\s/g, '').length) {
    errors.first_name = 'VALIDATORS.FIRST_NAME';
  }
  if (!values.last_name || !values.last_name.replace(/\s/g, '').length) {
    errors.last_name = 'VALIDATORS.LAST_NAME';
  }
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.email = 'VALIDATORS.EMAIL_REQ';
  } else if (!emailValidator(String(values.email).toLowerCase())) {
    errors.email = 'VALIDATORS.INVALID_EMAIL';
  }
  // if (!values.phone || !values.phone.replace(/\s/g, '').length) {
  //   errors.phone = 'VALIDATORS.INVALID_CONTACT_PHONE';
  // } else if (values?.phone?.length < 10) {
  //   errors.phone = 'VALIDATORS.INVALID_CONTACT_PHONE';
  // }
  if (!errors.first_name && !errors.last_name && !errors.email) {
    errors = {};
  }
  return errors;
};

export const createClinicGroupValidationWithHookForm = (values: any): any => {
  let errors: any = {
    clinic_group_name: '',
    primary_contact_email: '',
    state: '',
    admin_first_name: '',
    admin_last_name: ''
  };
  if (
    !values.clinic_group_name ||
    !values.clinic_group_name.replace(/\s/g, '').length
  ) {
    errors.clinic_group_name = 'VALIDATORS.CLINIC_GROUP_NAME';
  }
  if (
    !values.primary_contact_email ||
    !values.primary_contact_email.replace(/\s/g, '').length
  ) {
    errors.primary_contact_email = 'VALIDATORS.EMAIL_REQ';
  } else if (
    !emailValidator(String(values.primary_contact_email).toLowerCase())
  ) {
    errors.primary_contact_email = 'VALIDATORS.INVALID_EMAIL';
  }
  if (
    !values.admin_first_name ||
    !values.admin_first_name.replace(/\s/g, '').length
  ) {
    errors.admin_first_name = 'VALIDATORS.FIRST_NAME';
  }
  if (
    !values.admin_last_name ||
    !values.admin_last_name.replace(/\s/g, '').length
  ) {
    errors.admin_last_name = 'VALIDATORS.LAST_NAME';
  }
  if (!values.state || !values.state.replace(/\s/g, '').length) {
    errors.state = 'VALIDATORS.STATE';
  }
  if (
    !errors.clinic_group_name &&
    !errors.primary_contact_email &&
    !errors.state &&
    !errors.admin_first_name &&
    !errors.admin_last_name
  ) {
    errors = {};
  }
  return errors;
};

export const inviteUserValidationWithHookForm = (values: any): any => {
  let errors: any = {
    roles: '',
    accOfClinics: ''
  };
  if (values.roles && values.roles.length === 0) {
    errors.roles = 'VALIDATORS.ROLES';
  }
  // if (values.clinics && values.clinics.length === 0) {
  //   errors.accOfClinics = 'VALIDATORS.ACCESS_OF_CLINICS';
  // }
  if (!errors.roles && !errors.accOfClinics) {
    errors = {};
  }
  return errors;
};

export const addMachineValidationWithHookForm = (
  values: CardMachineFormType
): any => {
  let errors: any = {};
  if (!values.machine_name) {
    errors = {
      ...errors,
      machine_name: {message: 'VALIDATORS.MACHINE_NAME_REQUIRED'}
    };
  }
  if (!values.serial_number) {
    errors = {
      ...errors,
      serial_number: {message: 'VALIDATORS.SERIAL_NUMBER_REQUIRED'}
    };
  }
  if (!values.terminal_id) {
    errors = {
      ...errors,
      terminal_id: {message: 'VALIDATORS.TERMINAL_ID_REQUIRED'}
    };
  }
  if (!values.clinic_id) {
    errors = {
      ...errors,
      clinic_id: {message: 'VALIDATORS.PRACTICE_LOCATION_REQUIRED'}
    };
  }

  if (
    !errors.machine_name &&
    !errors.serial_number &&
    !errors.terminal_id &&
    !errors.clinic_id
  ) {
    errors = {};
  }
  return errors;
};

export const addProviderValidationWithHookForm = (
  values: ProviderFormType
): any => {
  let errors: any = {};
  if (!values.first_name || !values.first_name.replace(/\s/g, '').length) {
    errors = {
      ...errors,
      first_name: {message: 'VALIDATORS.PROVIDER_FIRST_NAME_REQUIRED'}
    };
  }
  if (!values.last_name || !values.last_name.replace(/\s/g, '').length) {
    errors = {
      ...errors,
      last_name: {message: 'VALIDATORS.PROVIDER_LAST_NAME_REQUIRED'}
    };
  }
  if (!values.npi) {
    errors = {
      ...errors,
      npi: {message: 'VALIDATORS.PROVIDER_NPI_REQUIRED'}
    };
  }
  if (!values.abbreviation) {
    errors = {
      ...errors,
      abbreviation: {message: 'VALIDATORS.ABBREVIATION_REQUIRED'}
    };
  }
  if (!values.spoken_name || !values.spoken_name.replace(/\s/g, '').length) {
    errors = {
      ...errors,
      spoken_name: {message: 'VALIDATORS.PROVIDER_SPOKEN_NAME_REQUIRED'}
    };
  }

  // else if (typeof values.npi === 'string' && values.npi.length !== 10) {
  //   errors = {
  //     ...errors,
  //     npi: {message: 'VALIDATORS.PROVIDER_NPI_LENGTH_REQUIRED'}
  //   };
  // }

  if (
    !errors.first_name &&
    !errors.last_name &&
    !errors.npi &&
    !errors.abbreviation
  ) {
    errors = {};
  }
  return errors;
};

export const addVaccineValidationWithHookForm = (values: any): any => {
  const errors: any = {};
  if (!values.vaccine_id) {
    errors.vaccine_id = {message: 'VALIDATORS.VACCINE_MODULE.NAME'};
  }
  if (!values.vaccine_price) {
    errors.vaccine_price = {message: 'VALIDATORS.VACCINE_MODULE.PRICE'};
  }
  return errors;
};

export const addClinicProviderValidationWithHookForm = (values: any): any => {
  const errors: any = {};
  if (!values.clinic_id) {
    errors.clinic_id = {message: 'VALIDATORS.PROVIDER_TAB.PRACTICE_NAME'};
  }
  if (!values.provider_id) {
    errors.provider_id = {message: 'VALIDATORS.PROVIDER_TAB.PROVIDER_NAME'};
  }
  return errors;
};

// The spoken name a provider defaults to, derived from their title's configured
// source. Each single-name source falls back to the other name, so a provider with
// only one of the two still gets a usable name. A missing source means the provider
// has no title, which falls back to the full name.
export const deriveProviderSpokenName = (
  firstName?: string | null,
  lastName?: string | null,
  nameSource?: string | null
): string => {
  const first = (firstName || '').trim();
  const last = (lastName || '').trim();
  const fullName = HelperUtils.fullName(first, last);

  const bySource: Record<string, string> = {
    [PROVIDER_SPOKEN_NAME_SOURCES.FIRST_NAME]: first || last,
    [PROVIDER_SPOKEN_NAME_SOURCES.LAST_NAME]: last || first,
    [PROVIDER_SPOKEN_NAME_SOURCES.FULL_NAME]: fullName
  };

  return bySource[nameSource || ''] || fullName;
};
